<div class="select-container">
  <div class="headbar">
    <app-customize-input [leftIcon]="'icon-search'" [placeholder]="'search' | translate" [(value)]="keyword">
    </app-customize-input>
    <div class="btn-close close-anim" (click)="close()">
      <i class="icon-error"></i>
    </div>
  </div>
  <div class="menu" *ngIf="!keyword">
    <mat-tab-group
      disableRipple="true"
      class="unit-mat-tab-group no-content"
      [selectedIndex]="selectIndex"
      (selectedIndexChange)="selectIndex !== $event && selectTab($event)"
    >
      <mat-tab [label]="'crypto' | translate"></mat-tab>
      <mat-tab [label]="'fiat_cur' | translate"></mat-tab>
    </mat-tab-group>
  </div>
  <div class="main-content" [@toggle]="tabToggleAnimateTick">
    <div class="title-bar" *ngIf="!keyword">
      <div class="tt">{{ 'my_favo_curr' | translate }}</div>
      <div class="btn-sort mutual-opacity" (click)="isSortAZ = !isSortAZ" [class.up]="!isSortAZ">
        <i class="icon-dep-download"></i>
      </div>
    </div>
    <app-scrollbar [hostPosition]="'relative'">
      <div class="options-container">
        <!-- 正常tab -->
        <ng-container *ngIf="!keyword">
          <ng-container
            *ngTemplateOutlet="
              currencyList;
              context: {
                data:
                  data.currencies | filterByKeyValue: 'isDigital' : selectIndex === 0 | sortByKey: 'currency' : isSortAZ
              }
            "
          ></ng-container>
        </ng-container>
        <!-- 搜索时，不分数字或法币 -->
        <ng-container *ngIf="keyword">
          <ng-container
            *ngTemplateOutlet="
              currencyList;
              context: {
                data: data.currencies | filterByText: keyword : ['currency', 'name']
              }
            "
          ></ng-container>
        </ng-container>
      </div>
    </app-scrollbar>
  </div>
</div>

<!-- 币种遍历列表 -->
<ng-template #currencyList let-data="data">
  <!-- 有数据 -->
  <ng-container *ngIf="data.length > 0; else noData">
    <ng-container *ngFor="let item of data">
      <ng-container *ngTemplateOutlet="currencyItem; context: { item: item }"></ng-container>
    </ng-container>
  </ng-container>
  <!-- 无数据 -->
  <ng-template #noData>
    <app-empty [text]="'search_unfind' | translate" [icon]="'assets/temp5/empty.png'"></app-empty>
  </ng-template>
</ng-template>

<!-- 币种栏 -->
<ng-template #currencyItem let-item="item">
  <div
    class="item onact96"
    (click)="clickItem(item)"
    [class.disabled]="item.currency === currentCurrencyData?.currency"
  >
    <div class="left">
      <img [src]="item.icon" />
      <span>{{ item.currency }}</span>
    </div>
    <div class="right">
      <mat-slide-toggle class="unit-mat-slide-toggle" [checked]="item.display" labelPosition="before">
        <span>{{ item.name }}</span>
      </mat-slide-toggle>
    </div>
  </div>
</ng-template>
